import React, { memo, useMemo } from 'react';
import { Button, createUseStyles } from '@Sage/hoi-poi-ui';
import { useWeb5Context } from 'lib/Web5Context';
import EmptyScreen from 'components/EmptyScreen';
import styles from './styles';
import { errorSvg, emptyGeneralSvg } from 'lib/svgs';

const useStyles = createUseStyles(styles, 'WidgetEmpty');

const Empty = memo(({ children, type, title, onRefresh }) => {
    const classes = useStyles();
    const { t } = useWeb5Context();

    const finalTitle = useMemo(() => {
        if (title) return title;
        if (type === 'error') return t('error_we_had_problem');
        return t('label_forcebi_no_results_with_specs');
    }, [type, title, t]);

    const illustration = useMemo(() => {
        if (type === 'error') return errorSvg;
        return emptyGeneralSvg;
    }, [type]);

    return (
        <div className={classes.root}>
            <EmptyScreen
                title={finalTitle}
                illustration={illustration}
                overrides={{
                    root: {
                        style: {
                            height: '100%',
                            marginTop: '0px',
                        },
                    },
                    emptyView: {
                        style: {
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                        },
                    },
                    illustration: {
                        style: {
                            width: type !== 'error' ? '150px' : '125px',
                            display: 'flex',
                            alignSelf: 'center',
                        },
                    },
                }}
            >
                {children}
                {onRefresh && (
                    <Button
                        className={classes.refresh}
                        type="secondary"
                        onClick={onRefresh}
                        onMouseDown={(e) => e?.stopPropagation()}
                    >
                        {t('action_refresh')}
                    </Button>
                )}
            </EmptyScreen>
        </div>
    );
});

export default Empty;
